export default {
    color: '#6f9dc5',
    weight: 5,
    opacity: 0.8,
    smoothFactor: 1
}
